var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useState } from 'react';
import { notification } from '../../core/components/Notification';
export function useAsyncCallback(callback, deps) {
    const [loading, setLoading] = useState(false);
    const newCallback = useCallback((...args) => __awaiter(this, void 0, void 0, function* () {
        try {
            setLoading(true);
            yield callback(...args);
        }
        catch (error) {
            notification.error({ content: error.message });
        }
        finally {
            setLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), deps);
    return [newCallback, loading];
}
//# sourceMappingURL=useAsyncCallback.js.map